export const operator1 = [
  {
    additionalInfo: {
      verified: true,
      instantConfirmation: true,
      payByApp: true,
    },
    _id: "65d6b639bb1369f6006dd3ee",
    name: "BB Vietnamese street food",
    email: "bbvnstreetfood@gmail.com",
    password: "$2a$10$tmMyIQXtQh2KZujX3H8uF.oJgGkhzBf1NRIsrB6HynmkEVC/Kbo/m",
    isAdmin: true,
    coverPhoto:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/coverbebau.png",
    photo: "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/logoBeBau.jpg",
    phone: "022 69 26 018",
    address: "BNZ Pavillion 2, 109 Cashel Street, Christchurch, New Zealand",
    bio: "brings the vibrant flavors of authentic Vietnamese street food to Christchurch",
    quote: " ",
    author: " ",
    __v: 0,
    createdAt: "2024-02-22T02:49:29.173Z",
    updatedAt: "2025-10-14T01:48:11.707Z",
    hasLoyalty: true,
    operatorType: "ordering",
    country: "New Zealand",
    profesional: ["Restaurant"],
    town: "Christchurch",
    openingHours: [
      {
        day: "Monday",
        slots: [],
        _id: "6884241567506621a017e084",
      },
      {
        day: "Tuesday",
        slots: [
          {
            open: "8:00 am",
            close: "6:00 pm",
            _id: "6884241567506621a017e086",
          },
        ],
        _id: "6884241567506621a017e085",
      },
      {
        day: "Wednesday",
        slots: [
          {
            open: "8:00 am",
            close: "6:00 pm",
            _id: "6884241567506621a017e088",
          },
        ],
        _id: "6884241567506621a017e087",
      },
      {
        day: "Thursday",
        slots: [
          {
            open: "8:00 am",
            close: "8:00 pm",
            _id: "6884241567506621a017e08a",
          },
        ],
        _id: "6884241567506621a017e089",
      },
      {
        day: "Friday",
        slots: [
          {
            open: "8:00 am",
            close: "6:00 pm",
            _id: "6884241567506621a017e08c",
          },
        ],
        _id: "6884241567506621a017e08b",
      },
      {
        day: "Saturday",
        slots: [
          {
            open: "8:00 am",
            close: "5:00 pm",
            _id: "6884241567506621a017e08e",
          },
        ],
        _id: "6884241567506621a017e08d",
      },
      {
        day: "Sunday",
        slots: [],
        _id: "6884241567506621a017e08f",
      },
    ],
    slug: "bb-vietnamese-street-food",
    otpCode: "581524",
    otpExpire: "2025-10-14T02:48:11.705Z",
  },
];

export const menuCategory = [
  {
    _id: "65d6c0d704261474450578b9",
    name: "RICE 3",
    image:
      "https://images.pexels.com/photos/12916862/pexels-photo-12916862.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2025-02-09T18:18:47.518Z",
  },
  {
    _id: "65d6c0d704261474450578b8",
    name: "ROLLS & SALAD",
    image:
      "https://images.pexels.com/photos/6645917/pexels-photo-6645917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578bc",
    name: "DRINK MENU",
    image:
      "https://images.pexels.com/photos/4457107/pexels-photo-4457107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578b7",
    name: "VERMICELLI",
    image:
      "https://images.pexels.com/photos/12034528/pexels-photo-12034528.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578b6",
    name: "SPECIAL",
    image:
      "https://images.pexels.com/photos/6646031/pexels-photo-6646031.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.078Z",
    updatedAt: "2024-02-22T03:34:47.078Z",
  },
  {
    _id: "65d6c0d704261474450578ba",
    name: "NOODLE",
    image:
      "https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578bb",
    name: "BANH MI MENU",
    image:
      "https://images.pexels.com/photos/14226647/pexels-photo-14226647.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "67791248cc320ae6162019f7",
    name: "THÔNG HÀ 123",
    image:
      "https://mediawinwin.vn/upload/images/sanpham/bao-gia-chup-mon-an-dich-vu-chup-anh-do-an-chuyen-nghiep-5.JPG",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
];

export const menuItems = [
  {
    _id: "65d6cc558845c39895773f1b",
    title: "BB Grilled porkvermicelli",
    price: 22,
    desc: "",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.850Z",
    updatedAt: "2024-02-22T04:23:49.850Z",
  },
  {
    _id: "65d6cc558845c39895773f21",
    title: "4. Stir fry vermicelli with chicken",
    price: 20,
    desc: "Chicken, lemongrass, vermicelli, lettuce, green\n        cabbage, red cabbage, mix salad, pickle, peanut,\n        shallot, soy sauce.",
    category: "65d6c0d704261474450578b7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f1c",
    title: "Spring rolls",
    price: 11,
    desc: "",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.850Z",
    updatedAt: "2024-02-22T04:23:49.850Z",
  },
  {
    _id: "65d6cc558845c39895773f1d",
    title: "Vietnamese icedsalted coffee",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f23",
    title: "6. Vietnamese spring rolls",
    price: 11,
    desc: "Pork, prawn, vermicelli, lettuce, cabbage,\n        shallot, peanut, hoisin sauce",
    category: "65d6c0d704261474450578b8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f29",
    title: "12. Hu tieu noodles soup",
    price: 22,
    desc: "Rice noodles, pork, pork mince, prawn,\n        quail egg, bean sprouts, garnish",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f2d",
    title: "B1. BB Combo breakfast skillet",
    price: 22,
    desc: "Beef, sausage, fried egg, Vietnamese ham, pork roll, pate, cheese, baguette ",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f2e",
    title: "B2. Mini Set of Banh MiBaguette,",
    price: 12,
    desc: "Mix 4 selections of Banh Mi",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f31",
    title: "B5. Grilled Pork Sausage Banh Mi",
    price: 11,
    desc: "Baguette, grilled pork sausage, pate, home-made butter, pickle, caramelized spring onion",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f3a",
    title: "Vietnamese iced black coffee",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f40",
    title: "Iced peach tea",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f24",
    title: "7. Tofu Vietnamese spring rolls",
    price: 11,
    desc: "Tofu, vermicelli, lettuce, cabbage, shallot, peanut,\n        hoisin sauce",
    category: "65d6c0d704261474450578b8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f25",
    title: "8. Deep fried spring rolls",
    price: 11,
    desc: "Pork, prawn, taro, carrot, wood ear mushroom",
    category: "65d6c0d704261474450578b8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f26",
    title: "9. Shaking Beef Rice",
    price: 21,
    desc: "Beef, capsicum, onion, Steam rice",
    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f27",
    title: "10. Suon Bi Cha Broken Rice",
    price: 22,
    desc: "Steam rice, chargrilled pork chop, egg, pickle,\n        shredded pork skin.",
    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f28",
    title: "11. Duong Chau Fried Rice",
    price: 22,
    desc: "Rice, BBQ pork, shrimp, Vietnamese sausage",
    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f2b",
    title: "14. Hu tieu chicken noodles soup",
    price: 22,
    desc: "Rice noodles, chicken, bean sprouts, garnish",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f30",
    title: "B4. Chicken Floss Banh Mi",
    price: 11,
    desc: "Baguette, chicken floss, pate, home-made butter,pickle, homemade sauce, spring onion, coriander,)",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f33",
    title: "B7. Meatballs Banh Mi",
    price: 11,
    desc: "Baguette, meatballs, home-made sauce,spring onion, coriander,",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f35",
    title: "B9. Chicken Satay Banh Mi",
    price: 11,
    desc: "Baguette, satay chicken, pickle, spring onion,corianderB1.",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f36",
    title: "B10. Grilled Pork Banh Mi",
    price: 11,
    desc: "Baguette pork, pate, home-made butter pickle, caramelized spring onion, homemadesauce.",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f38",
    title: "B12. Roasted Pork Banh Mi",
    price: 11,
    desc: "Baguette, roasted pork, pate, home-madebutter, pickle, homemade sauce, spring onion,coriander.",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f3b",
    title: "Vietnamese iced milk coffee",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f3d",
    title: "Shaved ice with strawberry syrup",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f41",
    title: "Iced lemon Thai tea",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f42",
    title: "Shaved ice with tamarind and peanuts",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f20",
    title: "3. Grilled beef skewers vermicelli",
    price: 20,
    desc: "Tofu, lemongrass, vermicelli, lettuce, green cabbage,\n        red cabbage, mix salad, pickle, peanut, shallot, soy\n        sauce",
    category: "65d6c0d704261474450578b7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f22",
    title: "5. Woven rice vermicelli",
    price: 21,
    desc: "Grilled Pork, salad, pickle, woven rice vermicelli,\n        Vietnamese dressing",
    category: "65d6c0d704261474450578b7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f2c",
    title: "15. Rice noodles with beef stew",
    price: 22,
    desc: "Beef stew, rice, carrot, bean sprouts, garnish",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f2f",
    title: "B3. BB Special Banh MiBaguette,",
    price: 12,
    desc: "Baguette, caramelized pork, Vietnamese ham,pate, cold pork, home-made butter, pickle,spring onion, coriander, homemade sauce)",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f32",
    title: "B6. Fork Floss Banh Mi",
    price: 11,
    desc: "Baguette, fork floss, pate, home-made butter,pickle, homemade sauce, spring onion,coriander",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f34",
    title: "B8. Grilled Beef Banh Mi",
    price: 11,
    desc: "Baguette, grilled beef skewer, pate, home-made\n        butter, pickle, homemade sauce, caramelized\n        spring onionBaguette",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f39",
    title: "B13. Vegeterian Banh Mi",
    price: 11,
    desc: "Tofu, vegetarian baguette, vegetarian source,caramelized spring onion, home-made butter,pickle.",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f43",
    title: "Plan custard",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.856Z",
    updatedAt: "2024-02-22T04:23:49.856Z",
  },
  {
    _id: "65d6cc558845c39895773f1e",
    title: "1. BB Grilled pork vermicelli",
    price: 23,
    desc: "Grilled pork, Vietnamese grilled pork mince, cured pork, deep fried spring rolls, quail egg, mixed salad,\n        pickles, crispy shallots, peanuts, Vietnamese dressing",
    category: "65d6c0d704261474450578b7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f1f",
    title: "2. Stir fry tofu with vermicelli",
    price: 20,
    desc: "Lemongrass grilled beef on skewers, vermicelli,\n        mixed salad, pickles, crispy shallots, peanuts,\n        Vietnamese dressing",
    category: "65d6c0d704261474450578b7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f2a",
    title: "13. Hu tieu seafood noodles soup",
    price: 22,
    desc: "Rice noodles, squid, pork mince, prawn, quail\n        egg, bean sprouts, garnish",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f37",
    title: "B11. Shredded Chicken Bun",
    price: 11,
    desc: "Baguette, shreddedchicken bun, pate,homemade butter,pickle, homemadesauce, spring onion,coriander.",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f3c",
    title: "Vietnamese iced salted coffee",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f3e",
    title: "Shaved ice with pandan syrup",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f3f",
    title: "Iced Lynchee tea",
    price: 8,
    desc: "",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "67a8e8ac70dbfd10965f1746",
    title: "Thong ha 2",
    price: 330,
    desc: "This this Thong Ha make",
    category: "67791248cc320ae6162019f7",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
];
